export default {
  'menu.RectificationRecordListPage': '整改上报',

  'app.rectificationRecordPage.attr.recordType.enum.CaseRecord': '案事件',
  'app.rectificationRecordPage.attr.recordType.enum.CompanyScoreOperateRecord': '扣分记录',

  'app.rectificationRecordPage.attr.status.enum.to_be_rectified': '待整改',
  'app.rectificationRecordPage.attr.status.enum.pending': '整改中',
  'app.rectificationRecordPage.attr.status.enum.awaiting_review': '待审核',
  'app.rectificationRecordPage.attr.status.enum.rectification_successed': '整改通过',
  'app.rectificationRecordPage.attr.status.enum.rectification_failed': '整改不通过',

  'app.rectificationRecordPage.event.call_allocate': '分配任务',
  'app.rectificationRecordPage.event.call_done': '整改上报',
  'app.rectificationRecordPage.event.call_audit_success': '审核通过',
  'app.rectificationRecordPage.event.call_audit_failure': '审核不通过',
}